import axiosInstance from "../../../interceptor/axiosInstance";
import {BOARDS, BOARDS_LIST} from "../../../routes/routeConstants/apiRoutes";
import {deserialize} from "serializr";
import Notification from "../../../shared/components/Notification";
import {NotificationTypes} from "../../../enums/notificationTypes";
import {Board, BoardModel} from "../../../models/CourseModels/BoardModel/board.model";
import {PaginationModel} from "../../../models/PaginationModel/pagination.model";

export default class BoardService {
    static getBoardsList(
        queryParams:string,
        onSuccess: Function,
        onError: Function,
        onFinal: () => void
    ) {
        return axiosInstance
            .get(BOARDS+queryParams)
            .then(response => {
                const boards = deserialize(BoardModel,response.data['boards']);
                const pageMeta = deserialize(PaginationModel,response.data['meta']);
                onSuccess(boards,pageMeta);
            })
            .catch(error => {
                Notification({ message: "Failed", description: "Unable to fetch the boards list",type: NotificationTypes.ERROR });
                onError(error);
            })
            .finally(onFinal)
    }

    static createBoard(
        data:any,
        onSuccess: Function,
        onError: Function,
        onFinal: () => void
    ) {
        return axiosInstance
            .post(BOARDS,data,{headers:{'Content-Type':'multipart/form-data'}})
            .then(response => {
                const board = deserialize(BoardModel,response.data['board']);
                onSuccess(board);
            })
            .catch(error => {
                Notification({ message: "Failed", description: "Unable to create the board",type: NotificationTypes.ERROR });
                onError(error);
            })
            .finally(onFinal)
    }

    static updateBoard(
        id:number,
        data:any,
        onSuccess: Function,
        onError: Function,
        onFinal: () => void
    ) {
        return axiosInstance
            .put(BOARDS+`/${id}`,data,{headers:{'Content-Type':'multipart/form-data'}})
            .then(response => {
                const board = deserialize(BoardModel,response.data['board']);
                onSuccess(board);
            })
            .catch(error => {
                Notification({ message: "Failed", description: "Unable to update the board",type: NotificationTypes.ERROR });
                onError(error);
            })
            .finally(onFinal)
    }

    static deleteBoard(
        id:number,
        onSuccess: Function,
        onError: Function,
        onFinal: () => void
    ) {
        return axiosInstance
            .delete(BOARDS+`/${id}`)
            .then(() => {
                onSuccess();
            })
            .catch(error => {
                Notification({ message: "Failed", description: "Unable to delete the board",type: NotificationTypes.ERROR });
                onError(error);
            })
            .finally(onFinal)
    }

  static getSelfRegisteredBoardsList(
    onSuccess: Function,
    onError: Function,
    onFinal: () => void
    ) {
    return axiosInstance
        .get(BOARDS_LIST)
        .then((response) => {
        const data = deserialize(Board, response.data.boards);
        
        onSuccess(data);
        })
        .catch((error) => {
        onError(error);
        })
        .finally(onFinal);
    }
}
